/* Prices are formatted by Liquid, never parsed or recalculated in the browser.
   This read-only enhancement must not interfere with the product form.
   Test: scripts/test-quantity-price-summary.mjs (runs without Shopify). */
if (!customElements.get('quantity-price-summary')) {
  customElements.define('quantity-price-summary', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const form = document.getElementById(this.getAttribute('form-id'));
      const output = this.querySelector('output');
      if (!(form instanceof HTMLFormElement) || !output) return;

      const update = () => {
        const quantity = form.elements.namedItem('quantity');
        const variant = form.elements.namedItem('id');
        const sellingPlan = form.elements.namedItem('selling_plan');
        // Die Menge kommt entweder als <select> oder -- seit den Gebinde-Kacheln --
        // als RadioNodeList. Beide liefern .value der aktiven Auswahl.
        const hasQuantity = quantity instanceof HTMLSelectElement || typeof quantity?.value === 'string';
        const valid = hasQuantity && !sellingPlan?.value;
        // Paket-Templates tragen ihre eigene Variante; alle anderen gehoeren
        // zur Variante des Produkts.
        const template = valid && Array.from(this.querySelectorAll('template[data-quantity]'))
          .find((item) => (item.dataset.variant ?? this.dataset.variantId) === String(variant?.value)
            && item.dataset.quantity === quantity.value.trim());
        const text = template ? template.content.textContent.trim() : '';
        if (output.textContent !== text) output.textContent = text;
        this.hidden = !text;
      };

      form.addEventListener('change', update, { signal });
      form.addEventListener('input', update, { signal });
      form.addEventListener('variant:change', update, { signal });
      form.addEventListener('gebinde:change', update, { signal });
      window.addEventListener('pageshow', update, { signal });
      update();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
